import React, { useState } from "react";

import { Button, Form, Modal, Row } from "react-bootstrap";

import MapForm from "./CandidateFillModalMap";
import Trash from "../../../../assets/svg/Trash";
import Up from "../../../../assets/svg/Up";

export interface ICandidateField {
  firstname: string;
  lastName: string;
  mail: string;
  phone: string;
  professionalSituation: string;
  familialSituation?: string;
  salary: string;
}

export interface IFields {
  familialSituation: any[];
  void: any[];
  firstname: any[];
  lastName: any[];
  mail: any[];
  phone: any[];
  professionalSituation: any[];
  salary: any[];
}

const CandidateFillModal = (props: any) => {
  const [validated] = useState(true);

  const handleClose = () => {
    props.setShow(false);
  };

  const mockupCandidate: ICandidateField = {
    firstname: "John",
    lastName: "Doe",
    mail: "John@Doe.com",
    phone: "0111111111",
    professionalSituation: "something",
    familialSituation: "Célibataire",
    salary: "700.89",
  };
  const mockupGuarantor: ICandidateField = {
    firstname: "Johan",
    lastName: "Dos",
    mail: "John@Dos.com",
    phone: "0222222222",
    professionalSituation: "something else",
    salary: "700.89",
  };

  const candidateList = [mockupCandidate];
  const guarantorList = [mockupGuarantor];

  //State of the in editing mode candidates' list
  const [candidatesList, setCandidatesList] = useState(candidateList);
  //State of the actual candidat's ID
  const [activeCandidateID, setActiveCandidateID] = useState(0);
  //State of the actual candidat's data
  const [candidate, setCandidate] = useState(
    Object.assign({}, candidatesList[activeCandidateID]),
  );

  //State of the in editing mode guarantor list
  const [guarantorsList, setGuarantorsList] = useState(guarantorList);
  //State of the saved guarantor list
  const [activeGuarantorID, setActiveGuarantorID] = useState(0);
  //State of the actual guarantor's data
  const [guarantor, setGuarantor] = useState(
    Object.assign({}, guarantorsList[activeGuarantorID]),
  );

  const handleAddRoomMates = () => {
    const roomMates: ICandidateField = {
      firstname: "",
      lastName: "",
      mail: "",
      phone: "",
      professionalSituation: "",
      familialSituation: "",
      salary: "",
    };
    const temp = candidatesList.copyWithin(0, candidatesList.length);
    temp.push(roomMates);
    setCandidatesList(temp);
    forceRerender();
  };

  const handleAddGuarantor = () => {
    const newGuarantor: ICandidateField = {
      firstname: "",
      lastName: "",
      mail: "",
      phone: "",
      professionalSituation: "",
      salary: "",
    };
    const temp = guarantorsList.copyWithin(0, guarantorsList.length);
    temp.push(newGuarantor);
    setGuarantorsList(temp);
    forceRerender();
  };

  const handleUpdateData = (
    e: any,
    id: number,
    element: ICandidateField,
    setter: (value: React.SetStateAction<ICandidateField>) => void,
    list: ICandidateField[],
    setterList: (value: React.SetStateAction<ICandidateField[]>) => void,
  ) => {
    let name = e.target.name;
    const value = e.target.value;
    if (name === "" && familialSituationValues.includes(value))
      name = "familialSituation";
    else if (
      name === "" &&
      guarantorProfessionalSituationValues.includes(value)
    )
      name = "professionalSituation";

    if (element !== undefined && name !== undefined) {
      element[name as keyof ICandidateField] = value; //TODO this line does not work as expected maybe?
      setter(element);
      const temp = list.copyWithin(0, list.length);
      temp[id] = element;
      setterList(temp);
      forceRerender();
    }
  };

  const handleCandidatSwitch = (i: number) => {
    setActiveCandidateID(i);
    setCandidate(candidatesList[i]);
  };

  const handleGuarantorSwitch = (i: number) => {
    setActiveGuarantorID(i);
    setGuarantor(guarantorsList[i]);
  };

  const handleCandidatDelete = (i: number) => {
    const temp = candidatesList.copyWithin(0, candidatesList.length);
    temp.splice(i, 1);
    setCandidatesList(temp);
    if (activeCandidateID !== 0 && activeCandidateID > i) {
      setActiveCandidateID(i);
      setCandidate(candidatesList[i]);
    }
    forceRerender();
  };

  const handleGuarantorDelete = (i: number) => {
    const temp = guarantorsList.copyWithin(0, guarantorsList.length);
    temp.splice(i, 1);
    setGuarantorsList(temp);
    if (guarantorsList.length === 0) {
      const newGuarantor: ICandidateField = {
        firstname: "",
        lastName: "",
        mail: "",
        phone: "",
        professionalSituation: "",
        salary: "",
      };
      setActiveGuarantorID(0);
      setGuarantor(newGuarantor);
    } else if (activeGuarantorID >= i) {
      setActiveGuarantorID(i);
      setGuarantor(guarantorsList[i]);
    }
    forceRerender();
  };

  const handleAbort = () => {
    //TODO
    //Fetch the saved data from the database and input it in states
    //setCandidatesList(candidatesList)
    //setGuarantorsList(guarantorsList)
    //forceRerender()
    if (candidatesList.length >= activeCandidateID)
      setCandidate(candidatesList[candidatesList.length - 1]);
    else setCandidate(candidatesList[activeCandidateID]);
    if (guarantorsList.length >= activeGuarantorID)
      setGuarantor(guarantorsList[guarantorsList.length - 1]);
    else setGuarantor(guarantorsList[activeGuarantorID]);
  };

  const handleSave = () => {
    //TODO Save to database the new data
    //let temp = candidatesList.copyWithin(0, candidatesList.length)
    //temp[activeCandidateID] = candidate
    //setCandidatesList(temp)
    handleClose();
  };

  const forceRerender = () => {
    const temp = candidate.firstname;
    setCandidate((prev) => ({ ...prev, firstname: "_-/_" }));
    setCandidate((prev) => ({ ...prev, firstname: temp }));
  };

  const handleValidateBtnFeedback = (element: ICandidateField): boolean => {
    for (const [key, value] of Object.entries(element)) {
      if (
        value.length === 0 ||
        (key === "mail" &&
          value.match(
            /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
          ) === null)
      )
        return false;
    }
    return true;
  };

  //Specific for select, use <hr/> to add it
  const familialSituationValues = [
    "single",
    "flatsharing",
    "pacs",
    "married",
    "inTheProcessOfDivorce",
    "pacsBeingDissolved",
  ];
  const familialSituationNames = [
    "Célibataire",
    "Colocataire",
    "Pacsé(e)s",
    "Marié(e)s",
    "En instance de divorce",
    "En cours de dissolution de Pacs",
  ];
  const professionalSituationValues = [
    "CDI",
    "CDITrial",
    "CDD",
    "alternant",
    "internship",
    "student",
    "publicService",
    "CTT",
    "retired",
    "unemployed",
    " independent",
    "situationNotDefined",
    "Other",
  ];
  const professionalSituationNames = [
    "CDI",
    "CDI (période d’essai)",
    "CDD",
    "Alternance",
    "Stage",
    "Étudiant",
    "Fonction publique",
    "CTT",
    "Retraité",
    "Sans emploi",
    "Indépendant",
    "Situation non définie",
    "Autre",
  ];
  const guarentorProfessionalSituationAddOns = [
    "Visale",
    "Garantme",
    "Unkle",
    "Cautioneo",
  ];
  const guarantorProfessionalSituationValues = [
    ...professionalSituationValues,
    ...guarentorProfessionalSituationAddOns,
  ];
  const guarantorProfessionalSituationNames = [
    ...professionalSituationNames,
    ...guarentorProfessionalSituationAddOns,
  ];

  //value: [type, data, (select values, select data)]

  const candidateFields: IFields = {
    familialSituation: [
      "select",
      "Situation Familiale",
      familialSituationValues,
      familialSituationNames,
    ],
    void: ["void"],
    firstname: ["text", "Prénom"],
    lastName: ["text", "Nom"],
    mail: ["email", "Email"],
    phone: ["text", "Téléphone"],
    professionalSituation: [
      "select",
      "Situation professionnelle",
      professionalSituationValues,
      professionalSituationNames,
    ],
    salary: ["number", "Salaire net (après impôt)"],
  };

  const guarantorFields: IFields = {
    familialSituation: [],
    void: [],
    firstname: ["text", "Prénom"],
    lastName: ["text", "Nom"],
    mail: ["email", "Email"],
    phone: ["text", "Téléphone"],
    professionalSituation: [
      "select",
      "Situation professionnelle",
      guarantorProfessionalSituationValues,
      guarantorProfessionalSituationNames,
    ],
    salary: ["number", "Salaire net (après impôt)"],
  };

  return (
    <>
      <Modal className="modal-team" show={props.show} onHide={handleClose}>
        <div className="d-flex flex-column justify-content-center m-4">
          <div className="mb-0 d-flex flex-row justify-content-between">
            <div className="d-flex flex-row justify-content-start gap-2 mb-0 pb-0">
              <h4 className="short-agenda-modal mt-3 mb-0  pt-2">
                <p className="fw-bold">Questionnaire locatif </p>
              </h4>
            </div>
            <Button
              type="button"
              variant="none"
              className="mb-0"
              onClick={handleClose}
            >
              <Up color="#000D5B" />
            </Button>
          </div>
          <div className="mt-0 text-muted text-start">
            Indiquez les situations professionnelles de chaque colocataire afin
            de savoir quels documents envoyer.
          </div>
          <hr className="mb-3" />
          <div className="d-flex flex-wrap gap-2">
            <div className="d-flex flex-column justify-content-start gap-2 me-4">
              {candidatesList.map((value, i) => {
                return (
                  <div
                    key={"candidate-btn-" + i}
                    className="d-flex flex-row justify-content-between"
                  >
                    <Button
                      type="button"
                      className={
                        handleValidateBtnFeedback(value) === true
                          ? "ms-0 w-100 text-start"
                          : activeCandidateID === i
                            ? "ms-0 w-100 text-start"
                            : "ms-0 w-100 text-start text-danger"
                      }
                      variant={
                        handleValidateBtnFeedback(value) === true
                          ? activeCandidateID === i
                            ? "primary"
                            : "none"
                          : activeCandidateID === i
                            ? "danger"
                            : "none"
                      }
                      role="button"
                      onClick={() => handleCandidatSwitch(i)}
                    >
                      {i === 0 ? "Vous" : "Colocataire n°" + i}
                    </Button>
                    {activeCandidateID !== i && i !== 0 && (
                      <Button
                        type="button"
                        className="ms-0"
                        variant="none"
                        role="button"
                        onClick={() => handleCandidatDelete(i)}
                      >
                        <Trash color={"red"} />
                      </Button>
                    )}
                  </div>
                );
              })}
              <Button
                type="button"
                className="ms-0 w-100"
                variant="primary"
                role="button"
                onClick={handleAddRoomMates}
              >
                <i className="bi bi-plus pt-1" style={{ fontSize: "16px" }}></i>{" "}
                Ajouter un colocataire
              </Button>
            </div>

            <div className="ms-3 w-75 flex-grow-3">
              <Form key={"candidate-form"} noValidate validated={validated}>
                {/* --- CANDIDATE PART --- */}
                <Row className="row-cols-1 row-cols-md-2">
                  <MapForm
                    field={candidateFields}
                    candidate={candidate}
                    update={handleUpdateData}
                    id={activeCandidateID}
                    setter={setCandidate}
                    list={candidatesList}
                    setterList={setCandidatesList}
                    type={"candidate"}
                  />
                </Row>
              </Form>
              <hr />
              <div className="mt-0 subtitle-2 text-muted text-start fw-bold">
                Garant(s)
              </div>
              <Form
                noValidate
                validated={validated}
                key={"guarantor-form"}
                className={
                  guarantorsList.length === 0 ? "overflow: hidden" : ""
                }
              >
                {/* --- GUARANTORS PART --- */}
                <div className="d-flex flex-row justify-content-start gap-2 flex-wrap">
                  {guarantorsList.map((value: ICandidateField, i) => {
                    return (
                      <div
                        key={"guarantor-btn-" + i}
                        className="d-flex flex-row justify-content-start gap-0 mt-2"
                      >
                        <Button
                          type="button"
                          className={
                            handleValidateBtnFeedback(value) === true
                              ? "ms-0"
                              : activeGuarantorID === i
                                ? "ms-0"
                                : "ms-0 text-danger"
                          }
                          variant={
                            handleValidateBtnFeedback(value) === true
                              ? activeGuarantorID === i
                                ? "primary"
                                : "none"
                              : activeGuarantorID === i
                                ? "danger"
                                : "none"
                          }
                          role="button"
                          onClick={() => handleGuarantorSwitch(i)}
                        >
                          {"Garant n°" + (i + 1)}
                        </Button>
                        {
                          <Button
                            type="button"
                            className="ms-0"
                            variant="none"
                            role="button"
                            onClick={() => handleGuarantorDelete(i)}
                          >
                            <Trash color={"red"} />
                          </Button>
                        }
                      </div>
                    );
                  })}
                </div>
                <Row className="row-cols-1 row-cols-md-2">
                  {guarantorsList.length > 0 && (
                    <MapForm
                      field={guarantorFields}
                      candidate={guarantor}
                      update={handleUpdateData}
                      id={activeGuarantorID}
                      setter={setGuarantor}
                      list={guarantorsList}
                      setterList={setGuarantorsList}
                      type={"guarantor"}
                    />
                  )}
                </Row>
              </Form>
              <Button
                type="button"
                className="ms-0 mt-4"
                variant="primary"
                role="button"
                onClick={handleAddGuarantor}
              >
                <i className="bi bi-plus pt-1" style={{ fontSize: "16px" }}></i>{" "}
                Ajouter un garant
              </Button>
            </div>
          </div>
          <hr />
          <div className="d-flex justify-content-end gap-4">
            <Button
              type="button"
              variant="outline-primary"
              className="ms-0"
              onClick={handleAbort}
            >
              Annuler
            </Button>
            <Button
              type="button"
              variant="success"
              className="ms-0"
              onClick={handleSave}
            >
              Valider
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CandidateFillModal;
